module.exports = __webpack_public_path__ + "static/img/patent-list.2e9d99f3.png";